import {
  VISUALITZACIO_INICIALITZAR,
  VISUALITZACIO_OMPLIR_ID_ESPECIE
} from "../../actions/actionTypes";

const ESTAT_INICIAL = null;

const idEspecie = (state = ESTAT_INICIAL, action) => {
  switch (action.type) {
    case VISUALITZACIO_INICIALITZAR:
      return ESTAT_INICIAL;

    case VISUALITZACIO_OMPLIR_ID_ESPECIE:
      return action.payload;

    default:
      return state;
  }
};

export default idEspecie;

export const getIdEspecie = state => state.idEspecie;
